import { RecertificationForm } from '../types';

export const recertificationDefaultConfig: RecertificationForm = {
  isDocumentTurnedOn: true,
  isVerbalAuthorizationTurnedOn: true,
};
